import {useCallback, useEffect, useState} from 'react';

/** SQ-660: how long a "why" line stays under a timer or the Job Total. */
export const TIMER_NOTICE_MS = 6000;

/** SQ-660: a "why" line that clears itself after a few seconds. */
export const useTimedNotice = (): [string | undefined, (text?: string) => void] => {
  const [notice, setNoticeState] = useState<string>();
  // Stable, so callers can name it in an effect's dependencies.
  const setNotice = useCallback((text?: string) => setNoticeState(text), []);
  useEffect(() => {
    if (!notice) return undefined;
    const timer = window.setTimeout(() => setNotice(undefined), TIMER_NOTICE_MS);
    return () => window.clearTimeout(timer);
  }, [notice]);
  return [notice, setNotice];
};
